// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"539c1f2e","703":"92b1fb64","787":"442be848"}[chunkId] + ".chunk.js";
};